import * as actionTypes from "./actionTypes";

export const setCurrentPrepaidBalance = ({ currentPrepaidBalance }) => ({
    type: actionTypes.SET_CURRENT_PREPAID_BALANCE,
    currentPrepaidBalance
});
